// Modules
import React from 'react';

// Material-ui
import Grid from '@mui/material/Grid';

// Helpers
import { LOCALE_FIN } from '@/lib/helpers';

// Components
// Common components
import { PrimaryButton, SecondaryButton } from '@/lib/components/Common/Buttons';
import {
  StyledDialog,
  StyledDialogContent,
  StyledDialogFooter,
  StyledDialogHeader,
  StyledDialogTitle,
} from '@/lib/components/Common/StyledElements';

export default function StyledDialogAlert({
  headerText,
  bodyText,
  cancelText = '',
  confirmText = '',
  action,
  handleClose,
  open,
  showCancel = true,
  hideAccept = false,
  actionClassName = '',
}: {
  headerText: string;
  bodyText: string;
  cancelText?: string;
  confirmText?: string;
  action: () => void;
  handleClose: () => void;
  open: boolean;
  showCancel?: boolean;
  hideAccept?: boolean;
  actionClassName?: string;
}) {
  function handleConfirm() {
    action();
    handleClose();
  }

  return (
    <StyledDialog open={open} fullWidth={false} maxWidth="sm">
      {headerText ? (
        <StyledDialogHeader>
          <Grid container alignItems="center">
            <StyledDialogTitle>{headerText}</StyledDialogTitle>
          </Grid>
        </StyledDialogHeader>
      ) : null}

      <StyledDialogContent>
        <Grid item>
          <p>{bodyText}</p>
        </Grid>
      </StyledDialogContent>

      <StyledDialogFooter>
        {showCancel ? (
          <SecondaryButton onClick={handleClose}>{cancelText || LOCALE_FIN.CANCEL}</SecondaryButton>
        ) : null}
        {!hideAccept ? (
          <PrimaryButton onClick={handleConfirm} className={actionClassName}>
            {confirmText || LOCALE_FIN.CONFIRM}
          </PrimaryButton>
        ) : null}
      </StyledDialogFooter>
    </StyledDialog>
  );
}
